module.exports = __webpack_public_path__ + "s/img/DSC_7423_4472x4472.4ba7a879.jpg";